import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.use(VueI18n)



var lang = {};
var dateTimeFormats = {};
//IMPORTO TODAS A DIRECTIVES AUTOMATICAMENTE DA PASTA DIRECTIVES
function requireAll(requireContext) {
    var keys = requireContext.keys()
    _.forEach(keys, k => {
        
        var modulo = requireContext(k)
        var nome = k.match(/([^/]*).js$/)
        // Vue.directive(nome[1], modulo.default)
        lang[nome[1]] = modulo.default

        dateTimeFormats[nome[1]] = modulo.default.dateFormates

    })
}

// requires and returns all modules that match
requireAll(require.context("./lang", true, /^\.\/.*\.js$/));


// export const VueI18n;


export const i18n = new VueI18n({
  locale: 'pt', // set locale
  fallbackLocale: 'pt',
  messages:lang, // set locale messages
  dateTimeFormats,
})


export function setI18nLanguage (lang) {
  i18n.locale = lang
//   axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}


export function loadLanguageAsync (lang) {

}


